import { DocumentSnapshot } from 'firebase/firestore';

import { PergolaConfiguration, PergolaConfigurationData } from '../types/configuration';

export const transformConfiguration = (document: DocumentSnapshot): PergolaConfiguration | null => {
  if (!document.exists) {
    return null;
  }

  const data = document.data({ serverTimestamps: 'estimate' });

  if (!data) {
    return null;
  }

  return {
    id: document.id,
    ...data as PergolaConfigurationData,
    createdAt: data.createdAt.toDate(),
    updatedAt: data.updatedAt.toDate()
  };
};